import { render } from "./Networksales.vue?vue&type=template&id=10249507"
import script from "./Networksales.vue?vue&type=script&lang=ts"
export * from "./Networksales.vue?vue&type=script&lang=ts"
script.render = render

export default script